import serverApi from "../utils/serverApi";

const propertiesService = {
  getList: (data) => serverApi({ uri: "properties", data, method: "GET" }),

  getFeatures: () => serverApi({ uri: "properties/features", method: "GET" }),

  getAvailableProperties: () => serverApi({ uri: "properties/available", method: "GET" }),

  getAvailablePropertiesForSwap: () => serverApi({ uri: "properties/available-for-swap", method: "GET" }),

  getPropertiesForCalculator: () => serverApi({ uri: "properties/for-calculator", method: "GET" }),

  getByUuid: async (uuid) => {
    return await serverApi({ uri: `properties/detail/${uuid}`, method: "GET" });
  },
  getStatusCount: () =>
    serverApi({ uri: "properties/status/count", method: "GET" }),

  getById: async (id) => {
    return await serverApi({ uri: `properties/${id}`, method: "GET" });
  },

  save: async (data) => {
    if (!data.id) {
      return await serverApi({ uri: "properties", data, method: "POST" });
    } else {
      return await serverApi({
        uri: `properties/${data.id}`,
        data,
        method: "PUT",
      });
    }
  },

  delete: async (id) =>
    serverApi({ uri: `properties/${id}`, method: "DELETE" }),

  getAnnualizedReturns: async (id) => {
    return await serverApi({
      uri: `properties/${id}/annualized-returns`,
      method: "GET",
      isLoading: false,
    });
  },

  getTopOwners: async (id) => {
    return await serverApi({
      uri: `properties/${id}/top-own`,
      method: "GET",
      isLoading: true,
    });
  },

  getMilestones: async (data) => {
    return await serverApi({
      uri: `properties/milestones/get-by-id`,
      method: "GET",
      data,
      isLoading: false,
    });
  },

  updateSoldTokens: async (propertyId, soldTokens, displaySoldTokens) => {
    return await serverApi({
      uri: `properties/${propertyId}/update-sold-tokens`,
      method: "PUT",
      data: { sold_tokens: soldTokens, display_sold_tokens: displaySoldTokens },
    });
  },

  publishProperty: async (data) => {
    return await serverApi({
      uri: `properties/publish/${data.id}`,
      method: "PUT",
      data,
    });
  },

  saveDetails: async (data) => {
    return await serverApi({
      uri: `properties/update-details/${data.id}`,
      method: "PUT",
      data,
    });
  },

  getFinancials: async (data) => {
    return await serverApi({
      uri: `properties/financials/get-by-id`,
      method: "GET",
      data,
      isLoading: false,
    });
  },

  checkTokenHolders: async (id) => {
    return await serverApi({
      uri: `properties/${id}/check-token-holders`,
      method: "GET",
      isLoading: false,
    });
  },

  getPrimaryImage: async (id) => serverApi({uri: `properties/${id}/primary-image`, method: 'GET'}),

  // Draft versioning
  getDraft: async (id) =>
    serverApi({ uri: `properties/${id}/draft`, method: 'GET', isLoading: false }),

  saveDraft: async (id, data) =>
    serverApi({ uri: `properties/${id}/draft`, method: 'PUT', data }),

  submitDraftForApproval: async (id) =>
    serverApi({ uri: `properties/${id}/draft/submit`, method: 'POST' }),

  approveDraft: async (id) =>
    serverApi({ uri: `properties/${id}/draft/approve`, method: 'POST' }),

  rejectDraft: async (id, reason) =>
    serverApi({ uri: `properties/${id}/draft/reject`, method: 'POST', data: { reason } }),

  createPropertyDraft: async (data) =>
    serverApi({ uri: 'properties/draft', method: 'POST', data }),

  cancelDraft: async (id) =>
    serverApi({ uri: `properties/${id}/draft`, method: 'DELETE' }),

  // Status-token scope draft
  getStatusTokenDraft: async (id) =>
    serverApi({ uri: `properties/${id}/status-token-draft`, method: 'GET', isLoading: false }),

  saveStatusTokenDraft: async (id, data) =>
    serverApi({ uri: `properties/${id}/status-token-draft`, method: 'PUT', data }),

  submitStatusTokenDraftForApproval: async (id) =>
    serverApi({ uri: `properties/${id}/status-token-draft/submit`, method: 'POST' }),

  approveStatusTokenDraft: async (id) =>
    serverApi({ uri: `properties/${id}/status-token-draft/approve`, method: 'POST' }),

  rejectStatusTokenDraft: async (id, reason) =>
    serverApi({ uri: `properties/${id}/status-token-draft/reject`, method: 'POST', data: { reason } }),

  cancelStatusTokenDraft: async (id) =>
    serverApi({ uri: `properties/${id}/status-token-draft`, method: 'DELETE' }),
};

export default propertiesService;
